import React, { useState } from "react";
import { Container, Row, Col, Pagination } from "react-bootstrap";
import FeaturedSlider from "../components/FeaturedSlider";
import PostCard from "../components/PostCard";
import Sidebar from "../components/Sidebar";
import { recentPosts } from "../data/posts";

const PER_PAGE = 6;

// Build a condensed page list with ellipsis, e.g. 1 … 4 5 6 … 13
function buildPageList(current, total) {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages = [1];
  const left = Math.max(2, current - 1);
  const right = Math.min(total - 1, current + 1);
  if (left > 2) pages.push("…");
  for (let i = left; i <= right; i++) pages.push(i);
  if (right < total - 1) pages.push("…");
  pages.push(total);
  return pages;
}

function Home() {
  const [page, setPage] = useState(1);
  const totalPages = Math.ceil(recentPosts.length / PER_PAGE);
  const start = (page - 1) * PER_PAGE;
  const pagePosts = recentPosts.slice(start, start + PER_PAGE);

  const goto = (p) => {
    setPage(p);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Container className="py-4">
      <FeaturedSlider />

      <Row className="g-4">
        {/* Main content */}
        <Col lg={8}>
          <h2 className="block-title">Latest Posts</h2>
          <Row className="g-4">
            {pagePosts.map((p) => (
              <Col md={6} key={p.id}>
                <PostCard post={p} />
              </Col>
            ))}
          </Row>

          {totalPages > 1 && (
            <Pagination className="pagination-wrap mt-4">
              <Pagination.Prev
                disabled={page === 1}
                onClick={() => goto(Math.max(1, page - 1))}
              />
              {buildPageList(page, totalPages).map((p, i) =>
                p === "…" ? (
                  <Pagination.Ellipsis key={`e${i}`} disabled />
                ) : (
                  <Pagination.Item
                    key={p}
                    active={page === p}
                    onClick={() => goto(p)}
                  >
                    {p}
                  </Pagination.Item>
                )
              )}
              <Pagination.Next
                disabled={page === totalPages}
                onClick={() => goto(Math.min(totalPages, page + 1))}
              />
            </Pagination>
          )}
        </Col>

        {/* Sidebar */}
        <Col lg={4}>
          <Sidebar />
        </Col>
      </Row>
    </Container>
  );
}

export default Home;
